<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{  'Delete Payment' | translate  }}</h3>
  </div> 
  <div class="col-md-2 col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>


<mat-dialog-content>
  <div class="row add-payment-modal">
    <div class="col-md-12">
      <p>Are you sure you want to delete?</p>

      <div class="mt-4">
        <button (click)="confirmDelete()" class="btn default-btn mr-3" mat-button>{{ 'Confirm' | translate }}</button>
        <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
 
